import { useMemo, useState } from "react";
import toast from "react-hot-toast";

const DUMMY_EMAILS = [
  {
    id: "1",
    email: "john.doe@example.com",
    name: "John Doe",
    status: "pending",
    createdAt: "2026-08-01T10:30:00Z",
  },
  {
    id: "2",
    email: "sarah.patel@example.com",
    name: "Sarah Patel",
    status: "pending",
    createdAt: "2026-08-02T14:15:00Z",
  },
  {
    id: "3",
    email: "mike.wilson@example.com",
    name: "Mike Wilson",
    status: "accepted",
    createdAt: "2026-07-28T09:00:00Z",
  },
  {
    id: "4",
    email: "emma.jones@example.com",
    name: "Emma Jones",
    status: "pending",
    createdAt: "2026-08-04T16:45:00Z",
  },
  {
    id: "5",
    email: "alex.kumar@example.com",
    name: "Alex Kumar",
    status: "pending",
    createdAt: "2026-08-05T11:20:00Z",
  },
  {
    id: "6",
    email: "priya.sharma@example.com",
    name: "Priya Sharma",
    status: "pending",
    createdAt: "2026-08-05T08:10:00Z",
  },
  {
    id: "7",
    email: "david.chen@example.com",
    name: "David Chen",
    status: "accepted",
    createdAt: "2026-07-25T13:40:00Z",
  },
  {
    id: "8",
    email: "lisa.martinez@example.com",
    name: "Lisa Martinez",
    status: "pending",
    createdAt: "2026-08-03T17:25:00Z",
  },
  {
    id: "9",
    email: "rahul.verma@example.com",
    name: "Rahul Verma",
    status: "pending",
    createdAt: "2026-08-06T09:15:00Z",
  },
  {
    id: "10",
    email: "olivia.brown@example.com",
    name: "Olivia Brown",
    status: "accepted",
    createdAt: "2026-07-30T11:50:00Z",
  },
  {
    id: "11",
    email: "james.taylor@example.com",
    name: "James Taylor",
    status: "pending",
    createdAt: "2026-08-02T07:35:00Z",
  },
  {
    id: "12",
    email: "neha.gupta@example.com",
    name: "Neha Gupta",
    status: "pending",
    createdAt: "2026-08-04T12:00:00Z",
  },
  {
    id: "13",
    email: "robert.anderson@example.com",
    name: "Robert Anderson",
    status: "pending",
    createdAt: "2026-08-01T15:20:00Z",
  },
  {
    id: "14",
    email: "sophia.lee@example.com",
    name: "Sophia Lee",
    status: "accepted",
    createdAt: "2026-07-27T10:05:00Z",
  },
  {
    id: "15",
    email: "amit.singh@example.com",
    name: "Amit Singh",
    status: "pending",
    createdAt: "2026-08-06T14:30:00Z",
  },
  {
    id: "16",
    email: "chloe.davis@example.com",
    name: "Chloe Davis",
    status: "pending",
    createdAt: "2026-08-03T09:45:00Z",
  },
  {
    id: "17",
    email: "vikram.reddy@example.com",
    name: "Vikram Reddy",
    status: "pending",
    createdAt: "2026-08-05T16:10:00Z",
  },
  {
    id: "18",
    email: "hannah.white@example.com",
    name: "Hannah White",
    status: "accepted",
    createdAt: "2026-07-26T08:55:00Z",
  },
  {
    id: "19",
    email: "carlos.rodriguez@example.com",
    name: "Carlos Rodriguez",
    status: "pending",
    createdAt: "2026-08-04T18:20:00Z",
  },
  {
    id: "20",
    email: "ananya.iyer@example.com",
    name: "Ananya Iyer",
    status: "pending",
    createdAt: "2026-08-02T13:15:00Z",
  },
  {
    id: "21",
    email: "daniel.clark@example.com",
    name: "Daniel Clark",
    status: "pending",
    createdAt: "2026-08-06T11:40:00Z",
  },
  {
    id: "22",
    email: "meera.nair@example.com",
    name: "Meera Nair",
    status: "accepted",
    createdAt: "2026-07-29T16:25:00Z",
  },
  {
    id: "23",
    email: "william.hall@example.com",
    name: "William Hall",
    status: "pending",
    createdAt: "2026-08-01T19:50:00Z",
  },
  {
    id: "24",
    email: "fatima.ali@example.com",
    name: "Fatima Ali",
    status: "pending",
    createdAt: "2026-08-03T14:35:00Z",
  },
  {
    id: "25",
    email: "ethan.wright@example.com",
    name: "Ethan Wright",
    status: "pending",
    createdAt: "2026-08-05T20:05:00Z",
  },
];

const formatDate = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
};

export default function AdminEmailList() {
  const [emails, setEmails] = useState(DUMMY_EMAILS);
  const [search, setSearch] = useState("");
  const [acceptingId, setAcceptingId] = useState("");

  const filteredEmails = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return emails;
    return emails.filter(
      (item) =>
        item.email.toLowerCase().includes(query) ||
        item.name.toLowerCase().includes(query)
    );
  }, [emails, search]);

  const pendingCount = emails.filter((item) => item.status === "pending").length;

  const handleAccept = async (id) => {
    setAcceptingId(id);
    try {
      // Dummy flow — replace with API call when backend is ready.
      await new Promise((resolve) => setTimeout(resolve, 400));
      setEmails((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: "accepted" } : item
        )
      );
      toast.success("Email accepted successfully.");
    } catch {
      toast.error("Could not accept email. Please try again.");
    } finally {
      setAcceptingId("");
    }
  };

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-[#F3F0FF]">
      <div className="flex-shrink-0 border-b border-violet-100 bg-white/80 px-4 py-4 sm:px-6 sm:py-5 backdrop-blur-sm">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">Email Approvals</h1>
            <p className="mt-1 text-sm text-gray-500">
              Review and accept registered email addresses. Dummy data for now.
            </p>
          </div>
          <div className="rounded-2xl border border-violet-100 bg-violet-50 px-4 py-2 text-sm text-violet-800">
            <span className="font-semibold">{pendingCount}</span> pending
          </div>
        </div>
      </div>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-4 py-4 sm:px-6 sm:py-6">
        <div className="mx-auto flex h-full min-h-0 w-full max-w-5xl flex-col gap-4">
          <div className="flex-shrink-0 rounded-2xl border border-violet-100 bg-white p-4 shadow-sm">
            <label htmlFor="email-search" className="mb-2 block text-sm font-medium text-gray-700">
              Search email
            </label>
            <input
              id="email-search"
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name or email..."
              className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm outline-none transition focus:border-[#7C4DFF] focus:ring-4 focus:ring-[#7C4DFF]/15"
            />
          </div>

          <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-violet-100 bg-white shadow-sm">
            <div className="hidden flex-shrink-0 grid-cols-[1.4fr_1fr_120px_120px] gap-4 border-b border-gray-100 bg-[#F9F8FF] px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500 md:grid">
              <span>Email</span>
              <span>Created</span>
              <span>Status</span>
              <span className="text-right">Action</span>
            </div>

            <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
              {filteredEmails.length === 0 ? (
                <div className="px-5 py-12 text-center text-sm text-gray-500">
                  No emails found.
                </div>
              ) : (
                <ul className="divide-y divide-gray-100">
                  {filteredEmails.map((item) => {
                    const isAccepted = item.status === "accepted";
                    const isAccepting = acceptingId === item.id;

                    return (
                      <li
                        key={item.id}
                        className="grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[1.4fr_1fr_120px_120px] md:items-center md:gap-4"
                      >
                        <div className="min-w-0">
                          <p className="truncate font-semibold text-gray-900">{item.email}</p>
                          <p className="truncate text-sm text-gray-500">{item.name}</p>
                        </div>

                        <div className="text-sm text-gray-600 md:text-left">
                          <span className="font-medium text-gray-500 md:hidden">Created: </span>
                          {formatDate(item.createdAt)}
                        </div>

                        <div>
                          <span
                            className={[
                              "inline-flex rounded-full px-3 py-1 text-xs font-semibold",
                              isAccepted
                                ? "bg-emerald-100 text-emerald-700"
                                : "bg-amber-100 text-amber-700",
                            ].join(" ")}
                          >
                            {isAccepted ? "Accepted" : "Pending"}
                          </span>
                        </div>

                        <div className="md:text-right">
                          <button
                            type="button"
                            disabled={isAccepted || isAccepting}
                            onClick={() => handleAccept(item.id)}
                            className="inline-flex min-w-[5.5rem] items-center justify-center rounded-xl bg-gradient-to-b from-[#7c4ff9] to-[#47299c] px-4 py-2 text-sm font-semibold text-white shadow-md transition hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            {isAccepting ? "..." : isAccepted ? "Accepted" : "Accept"}
                          </button>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
